import Payer from 'model/payer';
import { attr, fk, Model } from 'redux-orm';
import {
  createAction,
  createLoadConst,
  dateAndTime,
  formatMonth,
  fullName,
} from '../util';

const normalizeCard = (card) => ({
  ...card,
  payerId:
    card.payerId == null || Number.isNaN(Number(card.payerId))
      ? card.payerId
      : Number(card.payerId),
  cardNumber: card.cardNumberMask ?? card.cardNumber,
  cardholderName: fullName({
    firstName: card.cardHolderFirstName,
    lastName: card.cardHolderLastName,
  }),
  expirationDate:
    card.cardExpireMonth && card.cardExpireYear
      ? `${formatMonth(Number(card.cardExpireMonth), 'MMMM')} ${
          card.cardExpireYear
        }`
      : card.expirationDate,
  createdAtLabel: card.createdAt
    ? dateAndTime(card.createdAt)
    : card.createdAtLabel,
});

export default class DebitCard extends Model {
  static get modelName() {
    return 'DebitCard';
  }

  static reducer({ type, data }, DebitCard, { Payer }) {
    switch (type) {
      case LOAD.SUCCESS: {
        const rawPayerId = data?.props?.payerId;
        const payerId =
          rawPayerId == null || Number.isNaN(Number(rawPayerId))
            ? rawPayerId
            : Number(rawPayerId);

        if (Payer.idExists(payerId)) {
          Payer.withId(payerId).debitCards.delete();
        }

        const cardsFromResponse = data?.response?.cards ?? data?.response;
        const cards = Array.isArray(cardsFromResponse) ? cardsFromResponse : [];

        if (cards.length) {
          cards.forEach((card) => {
            DebitCard.upsert(normalizeCard(card));
          });
        }
        break;
      }

      default:
        break;
    }
  }

  static get fields() {
    return {
      cardId: attr(),
      cardExpireMonth: attr(),
      cardExpireYear: attr(),
      cardHolderFirstName: attr(),
      cardHolderLastName: attr(),
      cardNumber: attr(),
      cardNumberMask: attr(),
      cardInternal: attr(),
      cardType: attr(),
      cardholderName: attr(),
      cardStatus: attr(),
      createdAt: attr(),
      createdAtLabel: attr(),
      expirationDate: attr(),
      fspId: attr(),
      id: attr(),
      nickName: attr(),
      ownerType: attr(),
      cardToken: attr(),
      offset: attr(),
      uspsAddress: attr(),
      insertedUserId: attr(),
      insertedUser: attr(),
      insertedAdminUserId: attr(),
      updatedAdminUserId: attr(),
      updatedUserId: attr(),
      updatedUser: attr(),
      payerId: fk(Payer.modelName, 'debitCards'),
      updatedAt: attr(),
    };
  }
}

const name = DebitCard.modelName;

export const LOAD = createLoadConst(name);

export const load = createAction(LOAD);
